import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { icon, label } from "../../../config";
import { useWorkflowContext } from "../WorkflowContextProvider";
import SearchVariables from "./SearchVariables";
import { useSelectedVariableValues } from "./hooks/workflowVariables.hooks";
import { getUniqueVariableName } from "./services/workflowVariables.service";
import { VARIABLE_ICONS, WORKFLOW_VARIABLE_LABELS } from "./workflowVariables.constants";

const newVariableTypes = [
  {
    id: 1,
    variableName: "Dropdown",
    variableType: "dropdown",
  },
  {
    id: 2,
    variableName: "Textbox",
    variableType: "text",
  },
  {
    id: 3,
    variableName: "Date",
    variableType: "date",
  },
  {
    id: 4,
    variableName: "Number",
    variableType: "number",
  },
];
const VariableTypes = () => {
  const {
    customVariableTypes,
    workflowDefaults,
    setCustomVariableTypes,
    toggleVariableList,
    setToggleVariableList,
    setIsNewWorkflowVariable,
    setSelectedVariable,
    variableType,
    setVariableType,
  } = useWorkflowContext();

  const { workflowId } = useParams();
  const { setSelectedVariableValues } = useSelectedVariableValues();

  const [filteredVariableTypes, setFilteredVariableTypes] = useState([]);

  useEffect(() => {
    setCustomVariableTypes(workflowDefaults?.adminCustomVariables);
  }, [workflowDefaults?.adminCustomVariables]);

  const variableItemClickHandler = async (workflowVariable) => {
    const newVariableName = workflowId ? await getUniqueVariableName({ workflowId, adminVariableName: workflowVariable.variableName }) : "";
    setSelectedVariable(workflowVariable);
    setSelectedVariableValues(workflowVariable, newVariableName);
  };

  const backClickHandler = () => {
    setToggleVariableList(!toggleVariableList);
    setIsNewWorkflowVariable(false);
    setSelectedVariable(null);
    setVariableType("");
  };

  return (
    <>
      <div className='border p-3'>
        <div className='d-flex align-items-center gap-2 pb-3'>
          <span className='cursor-pointer' onClick={backClickHandler}>
            {icon.ARROW_BACK}
          </span>
          <span className='form-sub-heading'>{variableType}</span>
        </div>
        {variableType === WORKFLOW_VARIABLE_LABELS.PREFETCHED_FIELDS && (
          <div className='pb-3'>
            <label>Search Variables</label>
            <SearchVariables searchItems={customVariableTypes} setSearchItems={setFilteredVariableTypes} />
          </div>
        )}
        <div>
          {variableType === WORKFLOW_VARIABLE_LABELS.CUSTOM_CHIPS &&
            newVariableTypes?.map((variable) => {
              return (
                <>
                  <div key={variable.id} className='d-flex align-items-center justify-content-between p-2 cursor-pointer workflow-variable-item'>
                    <div className='d-flex align-items-start gap-2'>
                      <div className='d-flex flex-column'>
                        <span>{VARIABLE_ICONS[variable.variableType]}</span>
                      </div>
                      <div className='d-flex flex-column'>
                        <span>{variable.variableName}</span>
                      </div>
                    </div>
                    <span className='btn workflow-variable-add-field' onClick={() => variableItemClickHandler(variable)}>
                      {label.ADD}
                    </span>
                  </div>
                </>
              );
            })}
          {variableType === WORKFLOW_VARIABLE_LABELS.PREFETCHED_FIELDS &&
            filteredVariableTypes?.map((variable) => {
              return (
                <>
                  <div key={variable.Id} className='d-flex align-items-center justify-content-between p-2 cursor-pointer workflow-variable-item'>
                    <div className='d-flex align-items-start gap-2'>
                      <span>{icon.LOCK_ICON}</span>
                      <div className='d-flex flex-column'>
                        <span>{variable.variableName}</span>
                        <span>{WORKFLOW_VARIABLE_LABELS.ADMIN_FIELD}</span>
                      </div>
                    </div>
                    <span className='btn workflow-variable-add-field' onClick={() => variableItemClickHandler(variable)}>
                      {label.ADD}
                    </span>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default VariableTypes;
